<template>
  <div>
    <div v-for="asset in assets" :key="asset.display_name">
      <v-btn
        v-if="showEnabledBtn(asset)"
        block
        depressed
        class="existing-item-btn"
        @click="$emit('assetChosen', asset, assetType)"
      >
        <div class="existing-item-text">
          <span class="existing-item-name pl-0">{{ asset.displayName }}</span>
        </div>
        <div>
          <v-icon class="plus-icon" color="primary">{{
            icons.mdiPlusCircle
          }}</v-icon>
        </div>
      </v-btn>

      <v-btn
        v-if="showDisabledBtn(asset)"
        block
        depressed
        disabled
        class="existing-item-btn"
      >
        <div class="existing-item-text">
          <span class="existing-item-name pl-0">{{ asset.displayName }}</span>
          <br />
          <span class="list-item-more-info">{{
            disabledExplanation(asset)
          }}</span>
        </div>
        <div>
          <v-icon class="plus-icon" color="primary">{{
            icons.mdiPlusCircle
          }}</v-icon>
        </div>
      </v-btn>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ChooseAssetSection',
    props: {
      assets: {
        required: true,
        type: Array,
      },
      assetType: {
        required: true,
        type: String,
      },
      currentDonationAssetId: {
        required: false,
        type: String,
        default: null,
      },
    },
    methods: {
      propertyOwnedBySpouse(asset) {
        return (
          this.assetType == 'Property' && asset.ownership == 'SPOUSE_SOLE_OWNER'
        );
      },
      disabledExplanation(asset) {
        if (asset.specificDonation) {
          return '(asset already assigned)';
        } else if (this.propertyOwnedBySpouse(asset)) {
          return "(can't donate property owned by spouse)";
        }
      },
      showEnabledBtn(asset) {
        return (
          (!asset.specificDonation ||
            asset.id == this.currentDonationAssetId) &&
          !this.propertyOwnedBySpouse(asset)
        );
      },
      showDisabledBtn(asset) {
        return asset.specificDonation || this.propertyOwnedBySpouse(asset);
      },
    },
  };
</script>
